<script>
    import appConfig from "@/app.config";
    import {notificationMethods} from "@/state/helpers";
    import axios from 'axios';

    export default {
        name: "app",
        page: {
            // All subcomponent titles will be injected into this template.
            titleTemplate(title) {
                title = typeof title === "function" ? title(this.$store) : title;
                return title ? `${title} | ${appConfig.title}` : appConfig.title;
            }
        },
        mounted() {
        },
        created() {
            let vm = this;
            axios.interceptors.request.use(async (config) => {
                // const token = await vm.$auth.getTokenSilently();
              const token = await vm.$auth.getTokenPopup();
              if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            }, (error) => {
                return Promise.reject(error)
            });
        },
        watch: {
            /**
             * Clear the alert message on route change
             */
            // eslint-disable-next-line no-unused-vars
            $route(to, from) {
                // clear alert on location change
                this.clearNotification();
            }
        },
        methods: {
            clearNotification: notificationMethods.clear
        }
    };
</script>

<template>
    <div id="app">
        <transition
                name="fade"
                mode="out-in"
        >
            <RouterView/>
        </transition>
    </div>
</template>
